import { useEffect, useState } from "react";
import { CreativeType, CreativeMetaData } from 'types/creative';
import CreativeComponent from "components/atoms/CreativeComponent";
import { useAppState } from 'context';
import { classSize } from 'services/constants';


import "./CoolPage.scss";

const CoolPage = () => {
  const { screenSizeClass, creative = {} as CreativeType } = useAppState();
  const { media_asset: { metadata = {} as CreativeMetaData } = {}} = creative;
  const { aspect_ratio = 1.5} = metadata;
  const [crvProps, setCrvProps] = useState({});
  const isSocial = creative.playback_id === 4;

  useEffect(() => {
    if(creative.id){
      const newProps = {};
      if(isSocial || aspect_ratio < 1){
        newProps['height'] = 800;
        newProps['width'] = 400;
      } else {
        newProps['height'] = 350;
        newProps['width'] = 500;
      }
      setCrvProps(newProps);
    }
  }, [creative.id, aspect_ratio, isSocial])

  return ( 
    <div className={`web-view-container ${screenSizeClass}`}>
      COOL HTML PAGE
      <div className="overlay-player-web-view">
        <CreativeComponent {...crvProps} />
      </div>
    </div>
  );
};

export default CoolPage;
